<template>
    <div>
        <table style="width:100%" class="table-font">        
            <tr class="tr-bottom-border">
                <th colspan="2" class="td-left"><b>{{ this.title }}</b></th>
                <th class="td-right"><span v-if="current_size==='xs'">bkgs</span>
                                     <span v-else>bookings</span></th>
                <th class="td-right">value/pc</th>            
                <th class="td-right">rev./hour</th>                    
            </tr>                
            <tr>
                <td><span v-if="current_size==='xs'">Partners</span>
                    <span v-else>Revenue partners</span></td>
                <td class="td-right">{{ this.performance.total_turnover_partner }}</td>           
                <td class="td-right">{{ this.performance.total_bookings_partner }}</td>                
                <td class="td-right">{{ this.performance.avg_value_per_booking_partner }}</td>
                <td class="td-right">{{ this.performance.avg_turnover_per_hour_partner }}</td>                                   
            </tr>
            <tr>
                <td><span v-if="current_size==='xs'">Direct</span>
                    <span v-else>Revenue direct</span></td>
                <td class="td-right">{{ this.performance.total_turnover_direct }}</td>                
                <td class="td-right">{{ this.performance.total_bookings_direct }}</td>
                <td class="td-right">{{ this.performance.avg_value_per_booking_direct }}</td>
                <td class="td-right">{{ this.performance.avg_turnover_per_hour_direct }}</td>     
            </tr>
            <tr class="tr-bottom-top">
                <td>Totals</td>                
                <td class="td-right">{{ this.performance.total_turnover }}</td>
                <td class="td-right">{{ this.performance.total_bookings }}</td>
                <td class="td-right">{{ this.performance.avg_value_per_booking }}</td>              
                <td class="td-right">{{ this.performance.avg_turnover_per_hour }}</td>                
            </tr>
        </table>
    </div>
</template>

<script>

    import mxscreensize from '@/components/js/screensize';

    export default {     
        props: {
            performance: Object,
            title: String,
        },   
        mixins:[mxscreensize],
    }
</script>

<style scoped>
    .table-font{
        font-size:12px !important;
    }
    .td-right{
        text-align: end;        
    }
    .td-left{
        text-align:start;
    }    
    .tr-bottom-border{
        border: 1px solid lightblue;
        border-collapse: collapse;
        border-top: hidden;
        border-left: hidden;
        border-right: hidden;    

    }
    .tr-bottom-top{
        border: 1px solid lightblue;
        border-collapse: collapse;
        border-bottom: hidden;
        border-left: hidden;
        border-right: hidden;    

    }    
    .tr-right-border{
        border: 1px solid lightblue;
        border-collapse: collapse;
        border-bottom: hidden;
        border-left: hidden;
        border-top: hidden;  

    }        
    table,
    th,
    td {
        font-weight: 400 !important;
        border-collapse: collapse;
        padding-left: 15px;
        padding-top: 2px;
        padding-bottom: 2px;
        text-align:left;
    }      
</style>